import { AspectRatio, Image, rem } from '@mantine/core';
import { useMove } from '@mantine/hooks';
import { IconFocus } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from "react-i18next";

export const mapFocalPoint = ({ x, y }) => {
  const parsedX = parseFloat(x);
  const parsedY = parseFloat(y);

  const safeX = isNaN(parsedX) ? 0 : parsedX;
  const safeY = isNaN(parsedY) ? 0 : parsedY;
  
  const mappedX = (safeX * 2) - 1;
  const mappedY = -((safeY * 2) - 1);

  return { x: mappedX.toFixed(2), y: mappedY.toFixed(2) };
};

export const mapFocalPointReverse = ({ x, y }) => {
  const parsedX = parseFloat(x);
  const parsedY = parseFloat(y);

  const safeX = isNaN(parsedX) ? -1 : parsedX;
  const safeY = isNaN(parsedY) ? 1 : parsedY;

  const mappedX = (safeX + 1) / 2;
  const mappedY = (1 - safeY) / 2;

  return { x: mappedX.toFixed(2), y: mappedY.toFixed(2) };
};

export const ImageFocalPoint = ({ focalPoint, onChange, src = ''}) => {

    const { t } = useTranslation();

  const [value, setValue] = useState(mapFocalPointReverse(focalPoint) || { x: 0.5, y: 0.5});
  const { ref, active } = useMove((v) => {

    if(typeof onChange == 'function'){
      onChange(mapFocalPoint(v));
    }
    
    setValue(v);

  });

  return (

    <div ref={ref} style={{ display: 'flex', position: 'relative', }}>
      <AspectRatio ratio={0}>
        <Image
          src={src}
          alt={t('upload.avatar')}
          width="100%"
          height="100%"
          fit="cover"
        />
      </AspectRatio>
      <IconFocus
      strokeWidth={1.5}
      style={{
          position: 'absolute',
          left: `calc(${value.x * 100}% - ${rem(40)})`,
          top: `calc(${value.y * 100}% - ${rem(40)})`,
          width: rem(80),
          height: rem(80),
          opacity: active ? .75 : 1,
          color: active ? 'var(--mantine-color-gray-5)' : 'var(--mantine-color-white)',
        }}/>
    </div>
  )
}